import React, { useContext } from "react";
import { DAILY, MONTHLY, ONCE } from "./cohorts.constants";
import { AppContext } from "../../context";
import dayjs from "dayjs";
import { daysOfWeek } from "./CreateStep2";
import Trash from "../../assets/trash.svg";
import { convertTimeToMMHH } from "../../utils/timeHelpers";

function ScheduleTable() {
  const { formFields, updateContext } = useContext(AppContext);
  const { frequency, schedules, start_date } = formFields;
  return (
    <>
      <div className="py-[7px] px-3 w-full bg-light-tint mb-2">
        <p className="p-xs mb-0 font-medium text-dark">Summary</p>
      </div>
      <table className="border-collapse border border-slate-500 shadow-lg shadow-[#f4f4f4] rounded-[12px] overflow-hidden">
        <thead className="bg-gray-200">
          <tr>
            <th className="border border-[#dadada] p-2 text-gray-600">
              {frequency === MONTHLY || frequency === DAILY ? "DATE" : "DAY"}
            </th>
            <th className="border border-[#dadada] p-2 text-gray-600">
              START TIME
            </th>
            <th className="border border-[#dadada] p-2 text-gray-600">
              END TIME
            </th>
            <th>ACTION</th>
          </tr>
        </thead>
        <tbody>
          {schedules.map((sch, i) => (
            <tr key={i}>
              <td className="p-2 border border-[#dadada]">
                {frequency === ONCE
                  ? "Once"
                  : frequency === DAILY
                  ? dayjs(start_date).format("DD MMM YYYY")
                  : frequency === MONTHLY
                  ? dayjs(sch.date).format("DD MMM YYYY")
                  : `Every ${daysOfWeek[Number(sch.day_of_week - 1)]}`}
              </td>
              <td className="p-2 border border-[#dadada]">
                {sch.start_time ? convertTimeToMMHH(sch.start_time) : ""}
              </td>
              <td className="p-2 border border-[#dadada]">
                {sch.end_time ? convertTimeToMMHH(sch.end_time) : ""}
              </td>
              <td className="p-2 border border-[#dadada]">
                <span
                  className="text-[#c25151] p-1 cursor-pointer"
                  onClick={() => {
                    const newSchedule = schedules.filter((s, j) => j !== i);
                    updateContext({
                      ...formFields,
                      schedules: newSchedule,
                    });
                  }}
                >
                  <img src={Trash} alt="" className="w-[20px]" />
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export default ScheduleTable;
